/**
 * AUTO-GENERATED FILE - DO NOT EDIT MANUALLY
 * Generated by: scripts/generate-template-loaders.js
 * Source files:
 *   - courier-statement.njk
 *   - courier-statement.css
 */

export const COURIER_STATEMENT_TEMPLATE = `<div
  class="cs-container">
  <!-- Header Row (Logo & Store Info) -->
  <div class="cs-hdr-row">
    <div class="cs-hdr-left">
      {% if logoUrl %}
        <img class="cs-hdr-logo-img" src="{{ logoUrl }}" alt="{{ storeName }}"/>
      {% endif %}
    </div>
    <div class="cs-hdr-right">
      <div class="store-title">{{ storeName }}</div>
      {% if address %}
        <p>{{ address | replace('\\n', ', ') }}</p>
      {% endif %}
      {% if phone %}
        <p>Tel: {{ phone }}
          {% if whatsapp %}
            / WhatsApp: {{ whatsapp }}
          {% endif %}
        </p>
      {% endif %}
      {% if email %}
        <p>Email: {{ email }}</p>
      {% endif %}
      {% if website %}
        <p>Web: {{ website }}</p>
      {% endif %}
    </div>
  </div>
  <hr
  class="cs-divider"/>
  <!-- Statement Header Info -->
  <div class="cs-title-section">
    <h2 class="cs-title">Courier Statement</h2>
    <div class="cs-period">Period: {{ period }}</div>
    {% if settledFilter and settledFilter != "all" %}
      <div class="cs-filter-badge">
        View:
        {% if settledFilter == "unsettled" %}Unsettled Dues{% else %}Settled Dues{% endif %}
      </div>
    {% endif %}
    <div class="cs-generated-at">Generated: {{ generatedAt }}</div>
  </div>
  <!-- Courier Info Section -->
  <div class="cs-courier-card">
    <div class="cs-courier-title">COURIER DETAILS</div>
    <div class="cs-courier-grid">
      <span class="cs-courier-lbl">Courier Name:</span>
      <span class="cs-courier-val">{{ courierName }}</span>
      {% if courierPhone %}
        <span class="cs-courier-lbl">Contact No:</span>
        <span class="cs-courier-val">{{ courierPhone }}</span>
      {% endif %}
    </div>
  </div>
  <!-- Ledger Items Section -->
  <div class="cs-section">
    <div class="cs-section-title">Transactions / Bills</div>
    <table class="cs-table">
      <thead>
        <tr>
          <th style="width: 12%;">Order No</th>
          <th style="width: 25%;">Customer</th>
          <th style="width: 12%;">Date</th>
          <th style="width: 12%;">Status</th>
          <th style="width: 12%; text-align: right;">COD ({{ currency }})</th>
          <th style="width: 12%; text-align: right;">Fee ({{ currency }})</th>
          <th style="width: 12%; text-align: right;">Net ({{ currency }})</th>
          <th style="width: 15%;">Settlement</th>
        </tr>
      </thead>
      <tbody>
        {% for it in items %}
          <tr>
            <td class="font-medium">{{ it.order_no }}</td>
            <td>{{ it.customer_name }}</td>
            <td class="nowrap">{{ it.assigned_at_formatted }}</td>
            <td class="capitalize">{{ it.status }}</td>
            <td style="text-align: right;">
              {% if it.is_cod %}
                {{ it.cod_amount | formatPrice }}{% else %}—{% endif %}
            </td>
            <td style="text-align: right;">{{ it.delivery_fee | formatPrice }}</td>
            <td
              style="text-align: right;"
              class="font-medium {% if it.net > 0 %}text-green{% elif it.net < 0 %}text-red{% endif %}">
              {% if it.net > 0 %}+{% endif %}
              {{ it.net | formatPrice }}
            </td>
            <td>
              {% if it.noSettlementExpected %}
                <span class="text-muted">—</span>
              {% elif it.settled %}
                <span class="settled-info">
                  {{ it.payment_no }}
                  {% if it.payment_method_name %}<br/><small>{{ it.payment_method_name }}</small>
                  {% endif %}
                  {% if it.payment_date_formatted %}<br/><small>{{ it.payment_date_formatted }}</small>
                  {% endif %}
                </span>
              {% else %}
                <span class="text-unsettled">Unsettled</span>
              {% endif %}
            </td>
          </tr>
        {% endfor %}
        {% if items.length == 0 %}
          <tr>
            <td colspan="8" class="text-center text-muted py-4">
              No bills in this statement.
            </td>
          </tr>
        {% endif %}
      </tbody>
      <tfoot>
        <tr>
          <td colspan="4" class="text-right font-bold">Totals</td>
          <td style="text-align: right;" class="font-bold">{{ totals.cod | formatPrice }}</td>
          <td style="text-align: right;" class="font-bold">{{ totals.fee | formatPrice }}</td>
          <td
            style="text-align: right;"
            class="font-bold {% if totals.due > 0 %}text-green{% elif totals.due < 0 %}text-red{% endif %}">
            {% if totals.due > 0 %}+{% endif %}
            {{ totals.due | formatPrice }}
          </td>
          <td></td>
        </tr>
      </tfoot>
    </table>
  </div>
  <!-- Payments Section -->
  <div class="cs-section mt-5">
    <div class="cs-section-title">Payments Made / Collections Received</div>
    {% if payments.length > 0 %}
      <table class="cs-table">
        <thead>
          <tr>
            <th style="width: 15%;">Payment No</th>
            <th style="width: 15%;">Date</th>
            <th style="width: 15%;">Type</th>
            <th style="width: 18%; text-align: right;">Amount ({{ currency }})</th>
            <th style="width: 22%;">Method / Account</th>
            <th style="width: 15%;">Notes</th>
          </tr>
        </thead>
        <tbody>
          {% for p in payments %}
            <tr>
              <td class="font-medium">{{ p.payment_no }}</td>
              <td class="nowrap">{{ p.payment_date_formatted }}</td>
              <td class="capitalize">{{ p.type }}</td>
              <td
                style="text-align: right;"
                class="font-medium {% if p.type == 'collection' %}text-green{% elif p.type == 'payment' %}text-red{% endif %}">
                {% if p.type == 'collection' %}+{% elif p.type == 'payment' %}-{% endif %}
                {{ p.amount | formatPrice }}
              </td>
              <td>
                {{ p.payment_method_name }}
                {% if p.bank_account_name %}<br/><small>({{ p.bank_account_name }})</small>
                {% endif %}
              </td>
              <td>{{ p.notes or "—" }}</td>
            </tr>
          {% endfor %}
        </tbody>
        <tfoot>
          <tr>
            <td colspan="3" class="text-right font-bold">
              Net
              {% if totals.paid >= 0 %}Received{% else %}Paid{% endif %}
            </td>
            <td style="text-align: right;" class="font-bold">
              {% if totals.paid >= 0 %}+{% else %}-{% endif %}
              {{ totals.paid_abs | formatPrice }}
            </td>
            <td colspan="2"></td>
          </tr>
        </tfoot>
      </table>
    {% else %}
      <div class="cs-empty-box">
        No payments recorded in this period.
      </div>
    {% endif %}
  </div>
  <!-- Signatures Section -->
  <div class="cs-signature-section">
    <div class="cs-sig-block">
      <div class="cs-sig-line"></div>
      <div class="cs-sig-label">Courier Signature</div>
    </div>
    <div class="cs-sig-block">
      <div class="cs-sig-line"></div>
      <div class="cs-sig-label">Authorized Signature / Stamp</div>
    </div>
  </div>
  <!-- Footer -->
  <div class="cs-ftr">
    <div>Powered by TaproPOS</div>
  </div>
</div>`;

export const COURIER_STATEMENT_CSS = `@import url("https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap");

*,
*::before,
*::after {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

body {
  font-family:
    "Inter",
    -apple-system,
    BlinkMacSystemFont,
    "Segoe UI",
    Roboto,
    Oxygen,
    Ubuntu,
    Cantarell,
    sans-serif;
  font-size: var(--cs-font, 12px);
  color: #1a202c;
  background: var(--cs-bg, #fff);
  padding: var(--cs-body-pad, 0);
  line-height: 1.5;
  -webkit-print-color-adjust: exact;
  print-color-adjust: exact;
}

.cs-container {
  width: var(--cs-width, 210mm);
  max-width: 100%;
  margin: 0 auto;
  background: #fff;
  padding: var(--cs-pad, 10mm);
  border-radius: var(--cs-radius, 0);
  box-shadow: var(--cs-shadow, none);
  border: var(--cs-border, none);
}

/* Header Section */
.cs-hdr-row {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 15px;
}

.cs-hdr-left {
  max-width: 40%;
}

.cs-hdr-logo-img {
  max-height: 60px;
  max-width: 100%;
  object-fit: contain;
}

.cs-hdr-right {
  text-align: right;
  max-width: 55%;
}

.cs-hdr-right .store-title {
  font-size: 1.5em;
  font-weight: 700;
  color: #2d3748;
  margin-bottom: 4px;
}

.cs-hdr-right p {
  font-size: 0.9em;
  color: #718096;
  margin: 2px 0;
}

.cs-divider {
  border: none;
  border-top: 1px solid #e2e8f0;
  margin: 15px 0;
}

/* Title Section */
.cs-title-section {
  text-align: center;
  margin-bottom: 20px;
}

.cs-title {
  font-size: 1.6em;
  font-weight: 700;
  color: #1a202c;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 5px;
}

.cs-period {
  font-size: 1em;
  font-weight: 500;
  color: #4a5568;
}

.cs-filter-badge {
  display: inline-block;
  background: #edf2f7;
  color: #4a5568;
  font-size: 0.85em;
  font-weight: 600;
  padding: 3px 10px;
  border-radius: 9999px;
  margin-top: 5px;
}

.cs-generated-at {
  font-size: 0.8em;
  color: #a0aec0;
  margin-top: 5px;
}

/* Courier Details Card */
.cs-courier-card {
  background: #f7fafc;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  padding: 12px 15px;
  margin-bottom: 25px;
}

.cs-courier-title {
  font-size: 0.75em;
  font-weight: 700;
  color: #4a5568;
  letter-spacing: 0.5px;
  margin-bottom: 6px;
  text-transform: uppercase;
}

.cs-courier-grid {
  display: grid;
  grid-template-columns: 120px 1fr;
  gap: 6px 15px;
}

.cs-courier-lbl {
  font-weight: 500;
  color: #718096;
}

.cs-courier-val {
  font-weight: 600;
  color: #2d3748;
}

/* Section styling */
.cs-section {
  margin-bottom: 25px;
}

.cs-section-title {
  font-size: 1.1em;
  font-weight: 600;
  color: #2d3748;
  margin-bottom: 10px;
  border-bottom: 1.5px solid #e2e8f0;
  padding-bottom: 6px;
}

.cs-empty-box {
  border: 1px dashed #cbd5e0;
  border-radius: 6px;
  padding: 15px;
  text-align: center;
  font-size: 0.9em;
  color: #718096;
  background: #fcfcfc;
}

/* Table Styling */
.cs-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.95em;
}

.cs-table th {
  background: #f7fafc;
  border-bottom: 2px solid #e2e8f0;
  color: #4a5568;
  font-weight: 600;
  padding: 8px 10px;
  text-align: left;
}

.cs-table td {
  border-bottom: 1px solid #e2e8f0;
  padding: 8px 10px;
  vertical-align: top;
  color: #2d3748;
}

.cs-table tr:hover td {
  background: #fcfcfc;
}

.cs-table tfoot td {
  background: #f7fafc;
  border-top: 2px solid #cbd5e0;
  border-bottom: 2px solid #cbd5e0;
  padding: 8px 10px;
}

/* Utility classes inside table */
.font-medium {
  font-weight: 500;
}

.font-bold {
  font-weight: 700;
}

.text-right {
  text-align: right;
}

.text-center {
  text-align: center;
}

.nowrap {
  white-space: nowrap;
}

.capitalize {
  text-transform: capitalize;
}

.text-muted {
  color: #a0aec0;
}

.text-green {
  color: #276749 !important;
}

.text-red {
  color: #9b2c2c !important;
}

.text-unsettled {
  color: #d69e2e;
  font-weight: 500;
}

.settled-info {
  font-size: 0.85em;
  color: #4a5568;
  line-height: 1.3;
}

.settled-info small {
  color: #718096;
}

/* Signatures Section */
.cs-signature-section {
  display: flex;
  justify-content: space-between;
  margin-top: 50px;
  margin-bottom: 15px;
  padding: 0 10px;
}

.cs-sig-block {
  width: 220px;
  text-align: center;
}

.cs-sig-line {
  border-top: 1px solid #a0aec0;
  margin-bottom: 6px;
}

.cs-sig-label {
  font-size: 0.85em;
  font-weight: 500;
  color: #718096;
}

/* Footer Section */
.cs-ftr {
  text-align: center;
  margin-top: 35px;
  font-size: 0.85em;
  color: #a0aec0;
  border-top: 1px solid #e2e8f0;
  padding-top: 10px;
}

.mt-5 {
  margin-top: 1.25rem;
}

/* Print Overrides */
@media print {
  body {
    background: #fff !important;
    padding: 0 !important;
  }
  .cs-container {
    padding: 0 !important;
    box-shadow: none !important;
    border: none !important;
    width: 100% !important;
  }
  @page {
    size: var(--cs-page-size, A4);
    margin: 12mm 15mm;
  }
}
`;
